<template>
  <tr :class="{ upload: upload }">
    <td>
      <div class="name">
        <svg
          width="19"
          height="24"
          viewBox="0 0 19 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.99441 18H2.85315V19.5H3.99441C4.42238 19.5 4.70769 19.2 4.70769 18.75C4.70769 18.3 4.42238 18 3.99441 18ZM11.4126 0H0V24H18.5455V7.5L11.4126 0ZM5.99161 18.9C5.99161 20.1 5.13566 21 3.99441 21H2.85315V22.5H1.42657V16.5H3.99441C5.13566 16.5 5.99161 17.4 5.99161 18.6V18.9ZM11.8406 19.65C11.8406 21.15 10.6993 22.5 9.13007 22.5H7.13287V16.5H9.13007C10.5566 16.5 11.8406 17.7 11.8406 19.35V19.65ZM17.1189 18H14.2657V19.5H16.4056V21H14.2657V22.5H12.8392V16.5H17.1189V18ZM17.1189 15H1.42657V1.5H11.4126V7.5H17.1189V15ZM9.13007 18H8.55944V21H9.13007C9.98601 21 10.5566 20.4 10.5566 19.5C10.5566 18.6 9.84336 18 9.13007 18Z"
            fill="#277FAF"
          />
        </svg>
        <div class="text">
          <p>
            {{ item.name }}
          </p>
          <span class="f14">{{ fileSize ? fileSize : item.size }}</span>
        </div>
      </div>
      <BaseTableUploadProgress
        v-if="tableMin && upload"
        class="mt-2"
        :status="item.status"
        :uploadProgress="uploadDocumentsProgress"
      />
    </td>

    <td v-if="upload && !tableMin">
      <BaseTableUploadProgress :status="item.status" :uploadProgress="uploadDocumentsProgress" />
    </td>
    <template v-if="!upload">
      <td>
        {{ toJSDate(item.created_at) }}
      </td>
      <td>
        <div class="buttons">
          <ProjectSchemesAndDocumentsPdfModal icon-show :url="url" />
          <DeleteModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_free_documents',
              })
            "
            ref="deleteModal"
            :text="
              localStorage.translations.pages['setting-free_documents']['dialogs_titles'][
                'delete_document'
              ] +
              ' ' +
              item.name
            "
            :methodDelete="onDeleteDocument"
          />
        </div>
      </td>
    </template>
  </tr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteModal from 'components/DeleteModal'
import ProjectSchemesAndDocumentsPdfModal from 'components/project/schemesAndDocuments/ProjectSchemesAndDocumentsPdfModal'

export default {
  name: 'DocumentsShowTableItem',
  components: {
    DeleteModal,
    ProjectSchemesAndDocumentsPdfModal,
  },
  props: ['item', 'edit', 'upload', 'tableMin','downloadPageData'],
  data: () => ({
    valid: false,
    name: null,
    document_type_id: null,
    fileSize: null,
    fileExtension: null,
    url: null,
  }),
  watch: {
    item() {
      this.name = this.item.name
      this.document_type_id = this.item.type ? this.item.type.id : null
      if (this.item.files && !this.upload) {
        let filesData = JSON.parse(this.item.files)
        this.fileExtension = filesData[0].extension
        this.fileSize = filesData[0].size
      }
    },
    edit() {
      this.name = this.item.name
      this.document_type_id = this.item.type ? this.item.type.id : null
    },
  },
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('freeDocuments', ['uploadDocumentsProgress']),
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
  mounted() {
    this.document_type_id = this.item.type ? this.item.type.id : null
    if (this.item.file && !this.upload) {
      let filesData = JSON.parse(this.item.file)
      this.fileExtension = filesData[0].extension
      this.fileSize = filesData[0].size
      this.url = filesData[0].url
    }
  },
  methods: {
    ...mapActions('freeDocuments', ['onFreeDocumentsDelete']),
    // itemData() {
    //     this.$emit('itemData', {
    //         id: this.item.id,
    //         project_id: this.$route.params.id,
    //         name: this.name,
    //         document_type_id: this.document_type_id,
    //         files: this.item.files,
    //     })
    // },
    onDeleteDocument() {
      this.$store.dispatch('deleteFile', { url: this.url })
      this.onFreeDocumentsDelete(this.item.id)
        .then((response) => {
          console.log(response)
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications['uspeshno-udaleno'],
              IsError: false,
            },

            { root: true },
          )
          this.downloadPageData()
        })
        .catch((err) => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        })
    },
    toJSDate(dateTime) {
      var dateTime = dateTime.split(' ')
      var date = dateTime[0].split('-')
      var time = dateTime[1].split(':')
      let jsDate = new Date(date[0], date[1] - 1, date[2], time[0], time[1], 0)
      return (
        jsDate.toLocaleDateString() +
        ' ' +
        jsDate.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        })
      )
    },
  },
}
</script>

<style lang="scss" scoped>
tr:deep() {
  &.upload {
    background-color: #f8fcff;
    &:hover {
      background-color: #f8fcff !important;
    }
  }
  td {
    .name {
      display: grid;
      grid-template-columns: max-content auto;
      gap: 12px;
      align-items: center;
      .text {
        width: 100%;
        display: grid;
        p {
          margin: 0;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        span {
          display: block;
          color: #b4b4b4;
          font-weight: normal;
        }
      }
    }
    &.noSelect {
      color: #b4b4b4 !important;
    }

    .customBtn {
      margin-top: 5px;
    }
  }
}
</style>
